/* Maytrix RGB pricing and payment choice; no shared CPB config writes. */
(function () {
  'use strict';
  if (window.MaytrixReviewUpgrades || location.pathname.replace(/\/$/, '') !== '/products/custom-infinity-mirror') return;
  var copyNode = document.getElementById('myx-review-upgrades-copy');
  var copy = copyNode ? JSON.parse(copyNode.textContent) : {};
  // Public customizer orders are paid in full. Private quote deposits are separate.
  // Legacy shared links must never re-enable a deposit price.
  var deposit = false;
  var apiInstance, apiPromise, pending = Promise.resolve(), timer, activeFee = null, activeFactor = null, verification = null, ready = false, failure = false;
  var formulaIds = ['tX14tatW3yXJxrO5URxYho-S', '7uO5PNkADUu-amxwrPc4C-gm', 'pIbBRo_ZRkUp2lvaXOQ6nf0H', 'QLfvBw95td_3CACo_x8nITOd', 'EFQaeCTjJIApnWpvSTrzo39X'];
  var formulas = new Map();
  var lastPublishedPrice = null, observedSelection = '';
  function selectionKey(product) {
    return JSON.stringify((product?.layers || []).filter(function(layer){return !formulaIds.includes(layer.category);}).map(function(layer){return [layer.category,layer.option,layer.value];}));
  }
  var FRONT_KEY = 'FROCWEC233CN1!Dddv@1241D@FscC1C33';
  function rgbSelected(state) {
    function chosen(id, option) { return Boolean(document.querySelector('#product-builder [data-category-id="' + id + '"] [data-option-id="' + option + '"].cpb-active')); }
    var mode = chosen('rGBsXKwwThNiSwykhXb9lpED','rWXtJ2cizNDTFlzwzMg02cZw') ? 'Upload Logo' : chosen('rGBsXKwwThNiSwykhXb9lpED','B5S7IzJlXJTSkSRytUncLMJ9') ? 'Text' : 'Nothing';
    var center = state?.designMode === 'starrySky' ? state.starRgb : mode === 'Upload Logo' ? chosen('PBO5FoiL7WyPoltf_adurqLd', 'U26ig8IAviwEegpDnccLoKWd') : mode === 'Text' ? chosen('JTXoUcEXaLD_BdJU2yNZQFyU', 'tTf0yXrdMtSjTZSTE4VMrfja') : state?.designMode === 'starrySky' && state.starRgb;
    var style = chosen('-5rVa2YKJ10MFUHYFmKoRBJi','-dBd-M0uQbxoEHCzCzR54Nq5') ? 'Text Lighting' : chosen('-5rVa2YKJ10MFUHYFmKoRBJi','ZJSg8db4q4jyG9cxvr01gGZ5') ? 'Solid Bar Glow' : chosen('-5rVa2YKJ10MFUHYFmKoRBJi','zwNNqWwVjtWrME4Hxvt6F1RA') ? 'Point Light' : 'Nothing';
    var rails = chosen('THbeDdkyGpIlF50ZEPquqtSS', 'kX3EURGpNjUmWBD6hVR1FuFE') && chosen('fD2kHs7C9MhutByPyc8Fup71', 'Oo5VldkW23Qs2z1r_e_ppkGr');
    var sides = (style === 'Text Lighting' ? chosen('QIKsaieim4U8XmKkOQ26QBAt', 'tj_ofhE-BillnAjvXJdBsLEZ') || rails : /^(Solid Bar Glow|Point Light)$/.test(style) && chosen('UrSKZIETH8x08xhpeuDYPDaQ', '4o4kvtIr0TK3N1zhtLgIg2NQ'));
    var background = /^(logo|text)$/.test(String(state?.designMode || '')) && state.starBackgroundEnabled === true && state.starBackgroundRgb === true;
    return Boolean(center || sides || background);
  }
  function viewerState() { return window.__MAYTRIX_VIEWER__?.getState?.() || null; }
  function totalFee() { return rgbSelected(viewerState()) ? 30 : 0; }
  function paymentFactor() { return deposit ? 0.5 : 1; }
  // Recognize only the approved native Standard/130%-Priority formula. This
  // permits publishing this wrapper before the shared CPB formulas are saved.
  function unreducedFormula(base) {
    base = base.replace(/ \+ P_ONE__FRAME_COLOR_PRICE \+ P_THREE__CHOOSE_YOUR_LIGHT_COLOR_PRICE$/, '');
    var match = /^ROUND\(\(([\s\S]+)\) \* 0\.85; [02]\)$/.exec(base);
    return match ? match[1] : base;
  }
  function priceFactor() {
    return formulas.size === formulaIds.length && Array.from(formulas.values()).every(function (base) { return unreducedFormula(base) !== base; }) ? 0.85 : 1;
  }
  function rgbFeeLabel() { return money(3000); }
  function hasPriorityTotalFormula(base) {
    base = unreducedFormula(base);
    return /^\s*IF\(\s*P_FOUR__CHOOSE_YOUR_DELIVERY_WINDOW_VAL\s*=\s*0\.7\s*;/.test(base) && /\*\s*1\.30\s*;\s*2\s*\)\s*\)\s*$/.test(base);
  }
  function priorityDeliveryFactor(product) {
    var layers = product && product.layers;
    var selection = Array.isArray(layers) && layers.find(function (layer) { return layer.category === 'BGKHZ-5NH8Q20vxd1xZh8vGR'; });
    if (selection) {
      var value = Number(selection.value);
      if (value === 0.7) return 1;
      if (value === 1) return 1.3;
      if (selection.option === 'TNjvgFu-vgyVXjVWAr6LebiX') return 1.3;
      if (selection.option === 'DY2i27N9Go0mXkjzvcBCoTM5') return 1;
    }
    return document.querySelector('#product-builder [data-category-id="BGKHZ-5NH8Q20vxd1xZh8vGR"] [data-option-id="TNjvgFu-vgyVXjVWAr6LebiX"].cpb-active') ? 1.3 : 1;
  }
  function pricedFormula(base, fee, factor) {
    // Upgrades are fixed final prices, added after the mirror discount and delivery calculation.
    var addition = fee;
    var full = fee ? '(' + base + ' + ' + addition + ')' : base;
    if (fee && /\* 0\.85; 0\)$/.test(base)) full = 'ROUND(' + full + '; 0)';
    return factor === 0.5 ? (hasPriorityTotalFormula(base) ? 'ROUND((' + full + ') * 0.5; 2)' : '(' + full + ' * 0.5)') : full;
  }
  function calculateNativeQuote(formula, calculator, product) {
    // Read the same declared numeric variables as CPB; never evaluate JavaScript.
    var definitions = calculator.data.variables || [], values = Object.create(null);
    function variable(name) {
      if (Object.prototype.hasOwnProperty.call(values, name)) return values[name];
      var definition = definitions.find(function (item) { return item.key === name || item.userValue === name; });
      if (!definition || !definition.path) throw new Error('A pricing variable is unavailable');
      var parts = definition.path.split('.'), entity = {Product: product};
      parts.forEach(function (part) { entity = entity && entity[part]; });
      var value;
      if (definition.type === 'product') value = Number(entity);
      else {
        var optionIndex = parts.indexOf('options'), category = {Product: product};
        (optionIndex === -1 ? parts : parts.slice(0, optionIndex)).forEach(function (part) { category = category && category[part]; });
        if (!category || !category.id) throw new Error('A pricing category is unavailable');
        var matches = (product.layers || []).filter(function (layer) { return layer.category === category.id && (optionIndex === -1 || entity && layer.option === entity.id); });
        if (definition.type === 'price') value = matches.reduce(function (sum, layer) { return sum + Number(layer.price || 0); }, 0);
        else if (definition.type === 'value') value = Number(matches.length ? matches[0].value : 0);
        else throw new Error('A pricing variable is not numeric');
      }
      if (!Number.isFinite(value)) throw new Error('A pricing value could not be confirmed');
      values[name] = value; return value;
    }
    var tokens = formula.match(/[A-Z_][A-Z0-9_]*|\d+(?:\.\d+)?|<=|>=|[()+*/;=<>-]/g) || [], index = 0;
    if (tokens.join('') !== formula.replace(/\s/g, '')) throw new Error('The price formula is not supported');
    var precedence = {'=':1, '<=':1, '>=':1, '<':1, '>':1, '+':2, '-':2, '*':3, '/':3};
    function expression(minimum) {
      var token = tokens[index++], left;
      if (token === '(') { left = expression(0); if (tokens[index++] !== ')') throw new Error('The price formula is incomplete'); }
      else if (token === '-') left = -expression(4);
      else if (/^\d/.test(token || '')) left = Number(token);
      else if (token && token.indexOf('P_') === 0 || token && token.indexOf('PRODUCT_') === 0) left = variable(token);
      else {
        if (tokens[index++] !== '(') throw new Error('The price formula is incomplete');
        var args = [expression(0)]; while (tokens[index] === ';') { index++; args.push(expression(0)); }
        if (tokens[index++] !== ')') throw new Error('The price formula is incomplete');
        if (token === 'IF') left = args[0] ? args[1] : args[2];
        else if (token === 'MAX') left = Math.max.apply(Math, args);
        else if (token === 'MIN') left = Math.min.apply(Math, args);
        else if (token === 'ROUND' || token === 'ROUNDUP') {
          var scale = Math.pow(10, args[1]), absolute = Math.abs(args[0]) * scale;
          left = Math.sign(args[0]) * (token === 'ROUND' ? Math.round(absolute + 1e-7) : Math.ceil(absolute - 1e-7)) / scale;
        } else throw new Error('The price formula uses an unsupported function');
      }
      while (index < tokens.length && precedence[tokens[index]] >= minimum) {
        var operation = tokens[index++], right = expression(precedence[operation] + 1);
        if (operation === '+') left += right; else if (operation === '-') left -= right;
        else if (operation === '*') left *= right; else if (operation === '/') left /= right;
        else if (operation === '=') left = left === right; else if (operation === '<=') left = left <= right;
        else if (operation === '>=') left = left >= right; else if (operation === '<') left = left < right; else if (operation === '>') left = left > right;
      }
      return left;
    }
    var result = expression(0);
    if (index !== tokens.length || !Number.isFinite(result) || result <= 0) throw new Error('The full project price could not be confirmed');
    return Math.round(result * 100);
  }
  function exactFullPriceCents(product, fee) {
    var calculator = product.panels.flatMap(function (panel) { return panel.categories; }).find(function (category) { return formulaIds.includes(category.id) && apiInstance.checkLogic(category); });
    var base = calculator && formulas.get(calculator.id);
    if (!base || !hasPriorityTotalFormula(base)) return null;
    return calculateNativeQuote(pricedFormula(base, fee, 1), calculator, product);
  }
  function paymentSnapshot() {
    if (document.documentElement.dataset.myxSizePending === 'true') return null;
    if (!ready || activeFee !== totalFee() || activeFactor !== paymentFactor()) return null;
    var dueCents = Math.round(Number(apiInstance?.State.Product.price) * 100);
    if (!Number.isFinite(dueCents) || dueCents <= 0) return null;
    var quotedCents;
    try { quotedCents = exactFullPriceCents(apiInstance.State.Product, activeFee); } catch (_) { return null; }
    var totalCents = quotedCents === null ? Math.round(dueCents / activeFactor) : quotedCents;
    if (quotedCents !== null && dueCents !== Math.round(quotedCents * activeFactor)) return null;
    return { deposit: deposit, dueCents: dueCents, totalCents: totalCents, balanceCents: totalCents - dueCents };
  }
  function money(cents) { return '$' + (cents / 100).toLocaleString('en-US', {minimumFractionDigits: 0, maximumFractionDigits: 0}); }
  function decorateUrl(value) {
    if (!value) return value;
    try { var url = new URL(value, location.origin); url.searchParams.delete('myxu'); url.searchParams.delete('myxp'); return url.href; } catch (_) { return value; }
  }
  if (new URL(location.href).searchParams.has('myxu') || new URL(location.href).searchParams.has('myxp')) history.replaceState(history.state, '', decorateUrl(location.href));
  function properties() {
    var values = { 'Mounting': viewerState()?.mountingMethod === 'Self-standing' ? 'Self-standing' : 'Wall mount', 'RGB Upgrade': rgbSelected(viewerState()) ? 'Yes (+' + rgbFeeLabel() + ' once)' : 'No', '_Maytrix Upgrade Total': String(totalFee()) };
    var payment = paymentSnapshot();
    if (payment) {
      values['Payment'] = deposit ? '50% deposit' : 'Pay in full';
      values['_Maytrix Payment Percent'] = deposit ? '50' : '100';
      values['_Maytrix Full Price'] = money(payment.totalCents);
      values['_Maytrix Full Price Cents'] = String(payment.totalCents);
      values['_Maytrix Due Today Cents'] = String(payment.dueCents);
      values['_Maytrix Balance Cents'] = String(payment.balanceCents);
      if (deposit) {
        values['Full project price (each)'] = money(payment.totalCents);
        values['Deposit due today (each)'] = money(payment.dueCents);
        values['Remaining balance (each)'] = money(payment.balanceCents);
        values['Balance terms'] = 'The remaining 50% is invoiced separately after you approve photos or video of your finished mirror, before shipment.';
      }
    }
    return values;
  }
  function getApi() {
    if (!window.CPB?.createFrontApi) return Promise.resolve(null);
    if (!apiPromise) apiPromise = window.CPB.createFrontApi(FRONT_KEY).then(function (api) { if (!api.getAuthStatus().isAuthorized) throw new Error('Pricing authorization unavailable'); apiInstance = api; return api; }).catch(function (e) { apiPromise = null; throw e; });
    return apiPromise;
  }
  async function updatePricing() {
    if (document.documentElement.dataset.myxSizePending === 'true') return false;
    if (!viewerState() || document.querySelector('#product-builder .cpb-loader')) return false;
    var api = await getApi(); if (!api) return false;
    var product = api.State.Product;
    if (!product?.panels?.length) return false;
    var selection = selectionKey(product);
    var fee = totalFee(), factor = paymentFactor(), feeRate = 1;
    var changed = false, count = 0, previousFormulaMatches = activeFee !== null, baseFormulaMatches = true;
    var priceBefore = Number(product.price);
    product.panels.forEach(function (panel) {
      panel.categories.forEach(function (category) {
        if (!formulaIds.includes(category.id)) return;
        count++;
        if (!formulas.has(category.id)) {
          var original = category.data?.formula;
          if (typeof original !== 'string' || !original.trim() || /PAYMENT_OPTION|DEPOSIT/i.test(original)) throw new Error('Unrecognized full-price formula');
          // Current base calculation has no RGB surcharge. Fail closed if shared pricing changes.
          if (/MAKE_YOUR_LOGO_RGB|0\.05|MYX_UPGRADES/i.test(original)) throw new Error('Base RGB pricing requires review');
          formulas.set(category.id, original);
        }
        var base = formulas.get(category.id);
        // The upgrade stays $30 with either delivery option.
        baseFormulaMatches = baseFormulaMatches && category.data.formula === base;
        var previous = pricedFormula(base, activeFee, activeFactor);
        previousFormulaMatches = previousFormulaMatches && category.data.formula === previous;
        var next = pricedFormula(base, fee, factor);
        if (category.data.formula === next) return;
        var updated = JSON.parse(JSON.stringify(category)); updated.data.formula = next;
        api.dispatch({ type: 'Product/productCategoryUpdate', payload: { data: updated, panelId: panel.id } });
        changed = true;
      });
    });
    if (count !== formulaIds.length) throw new Error('Not all base price formulas are available');
    var expectedPrice = previousFormulaMatches && (activeFee !== fee || activeFactor !== factor) && priceBefore > 0 ? Math.round((priceBefore / activeFactor + (fee - activeFee) * feeRate) * factor * 100) / 100 : null;
    if (activeFee === null && baseFormulaMatches && priceBefore > 0) expectedPrice = Math.round((priceBefore + fee * feeRate) * factor * 100) / 100;
    var quotedCents = exactFullPriceCents(product, fee);
    if (quotedCents !== null) expectedPrice = Math.round(quotedCents * factor) / 100;
    if (expectedPrice !== null) verification = { price: expectedPrice, fee: fee, factor: factor, feeRate: feeRate };
    else if (verification && verification.fee === fee && verification.factor === factor && verification.feeRate === feeRate) expectedPrice = verification.price;
    if (changed || (activeFee !== null && (activeFee !== fee || activeFactor !== factor)) || failure || (quotedCents !== null && Math.round(priceBefore * 100) !== Math.round(expectedPrice * 100))) {
      var current = api.State.Product;
      var calculatorPanel = current.panels.find(function (panel) { return panel.categories.some(function (category) { return formulaIds.includes(category.id) && api.checkLogic(category); }); });
      var calculator = calculatorPanel?.categories.find(function (category) { return formulaIds.includes(category.id) && api.checkLogic(category); });
      if (!calculator?.options?.length || calculator.type !== 'calculateFields') throw new Error('Price calculator is not ready');
      // Refresh the applicable calculated field through CPB's normal pricing worker.
      // Calculated-field options refresh without toggling customer selections.
      var refreshCalculatedPrice = function () { return api.updateOptions({ panel: { id: calculatorPanel.id, title: calculatorPanel.title }, category: JSON.parse(JSON.stringify(calculator)), options: [JSON.parse(JSON.stringify(calculator.options[0]))] }); };
      await refreshCalculatedPrice();
      if (selectionKey(api.State.Product) !== selection || document.documentElement.dataset.myxSizePending === 'true') { schedule(); return false; }
      if (expectedPrice !== null && (quotedCents !== null ? Math.round(Number(api.State.Product.price) * 100) !== Math.round(expectedPrice * 100) : Math.abs(Number(api.State.Product.price) - expectedPrice) > 0.01)) await refreshCalculatedPrice();
      if (expectedPrice !== null && (quotedCents !== null ? Math.round(Number(api.State.Product.price) * 100) !== Math.round(expectedPrice * 100) : Math.abs(Number(api.State.Product.price) - expectedPrice) > 0.01)) throw new Error('The selected payment amount could not be verified');
    }
    var after = api.State.Product;
    if (selectionKey(after) !== selection || document.documentElement.dataset.myxSizePending === 'true') { schedule(); return false; }
    if (!Number.isFinite(Number(after.price)) || Number(after.price) <= 0) throw new Error('The price could not be confirmed');
    var announce = changed || activeFee !== fee || activeFactor !== factor || !ready || lastPublishedPrice !== Number(after.price);
    activeFee = fee; activeFactor = factor; verification = null; ready = fee === totalFee() && factor === paymentFactor(); failure = false; delete document.documentElement.dataset.myxUpgradeError;
    lastPublishedPrice = Number(after.price);
    if (announce) { document.dispatchEvent(new CustomEvent('maytrix:upgrades-priced')); document.dispatchEvent(new CustomEvent('maytrix:payment-change')); }
    render(); return true;
  }
  function sync() {
    pending = pending.catch(function () {}).then(updatePricing).catch(function (error) { ready = false; failure = true; document.documentElement.dataset.myxUpgradeError = error.message; console.error('[Maytrix upgrades] Could not confirm upgrade price.', error); render(); return false; });
    return pending;
  }
  function schedule() { clearTimeout(timer); timer = setTimeout(function () { timer = null; sync(); }, 350); }
  function renderPayment(review) {
    if (window.MaytrixAffirm) {
      var affirmSection = review.querySelector('[data-myx-payment-section]');
      if (!affirmSection) {
        affirmSection = document.createElement('section');
        affirmSection.className = 'myx-review-payment myx-review-financing';
        affirmSection.dataset.myxPaymentSection = '';
        affirmSection.setAttribute('aria-label', 'Payment options');
        review.querySelector('.myx-review__desktop-purchase')?.before(affirmSection);
      }
      review.querySelectorAll('.myx-review-financing__title').forEach(function (node) { node.remove(); });
      var snapshot = paymentSnapshot();
      review.querySelectorAll('.myx-review__mobile-bar [data-myx-affirm-message]').forEach(function (node) { node.remove(); });
      [affirmSection].forEach(function (container) {
        var message = container.querySelector('[data-myx-affirm-message]');
        if (!message) {
          message = document.createElement('p');
          message.className = 'myx-affirm-message';
          message.dataset.myxAffirmMessage = '';
          message.dataset.pageType = 'product';
          message.dataset.affirmColor = 'white';
          message.dataset.learnmoreShow = 'true';
          container.prepend(message);
        }
        window.MaytrixAffirm.setAmount(message, snapshot && snapshot.totalCents);
      });
      return;
    }
    var section = review.querySelector('[data-myx-payment-section]');
    if (!section) {
      section = document.createElement('section'); section.className = 'myx-review-payment myx-review-financing'; section.dataset.myxPaymentSection = '';
      section.setAttribute('aria-label', 'Payment options');
      section.innerHTML = '<p class="myx-review-financing__title">Pay over time with <strong>Affirm</strong><span aria-hidden="true"> · </span><a class="myx-review-financing__link" href="https://shoppay.affirm.com/" target="_blank" rel="noopener" aria-label="Learn more about Affirm through Shop Pay Installments, subject to eligibility">Learn more</a></p>';
      review.querySelector('.myx-review__desktop-purchase')?.before(section);
    }
    review.querySelectorAll('[data-myx-mobile-financing]').forEach(function (node) { node.remove(); });
  }

  function render() {
    var review = document.getElementById('myx-design-review'); if (!review) return;
    renderPayment(review);
    var summary = review.querySelector('[data-myx-summary]');
    if (summary) {
      var row = summary.querySelector('[data-myx-upgrade-summary="2"]');
      if (!row) {
        row = document.createElement('div'); row.className = 'myx-review__summary-row'; row.dataset.myxUpgradeSummary = '2';
        var term = document.createElement('dt'); term.textContent = 'RGB upgrade'; row.appendChild(term);
        var value = document.createElement('dd'); value.textContent = rgbFeeLabel() + ' once across your design'; row.appendChild(value); summary.appendChild(row);
      }
      row.querySelector('dd').textContent = rgbFeeLabel() + ' once across your design';
      row.hidden = !rgbSelected(viewerState());
    }
    var paymentSection = review.querySelector('[data-myx-payment-section]');
    var status = paymentSection.querySelector('[data-myx-pricing-status]');
    if (!status) {
      status = document.createElement('p'); status.className = 'myx-review-upgrades__status'; status.dataset.myxPricingStatus = ''; status.setAttribute('aria-live', 'polite'); paymentSection.appendChild(status);
    }
    var statusText = failure ? (copy.priceError || 'We couldn’t update your total. Please try again.') : '';
    if (status.textContent !== statusText) status.textContent = statusText;
    status.hidden = !statusText;

  }
  window.MaytrixReviewUpgrades = Object.freeze({ priceFactor: priceFactor, decorateUrl: decorateUrl, properties: properties, payment: paymentSnapshot, isDeposit: function () { return deposit; }, ensureReady: async function () { clearTimeout(timer); timer = null; var confirmed = await sync(); if (!confirmed || !paymentSnapshot()) throw new Error('Please wait for your payment total to finish updating.'); }, refresh: schedule });
  // Selection attributes update after CPB has finished its own pricing worker.
  // Do not trigger a competing calculation from the initial click/input event.
  document.addEventListener('maytrix:starlight-background-change', schedule);
  document.addEventListener('maytrix:size-pending', function(){ready=false;document.dispatchEvent(new CustomEvent('maytrix:payment-change'));});
  document.addEventListener('maytrix:size-committed', schedule);
  document.body.addEventListener('CPB_ON_OPTIONS_UPDATE', schedule);
  // Numeric values can change without an aria/class mutation. Observe the
  // committed selections too; this does no recalculation when they are unchanged.
  setInterval(function(){
    if(document.hidden || !apiInstance) return;
    var current=selectionKey(apiInstance.State.Product);
    if(current!==observedSelection){observedSelection=current;schedule();}
  },1000);
  document.addEventListener('visibilitychange', function () { if (!document.hidden) schedule(); });
  window.addEventListener('popstate', function () {
    history.replaceState(history.state, '', decorateUrl(location.href));
    render(); schedule();
  });
  var boot = setInterval(function () { render(); sync(); if (ready) clearInterval(boot); }, 600);
  setTimeout(function () { clearInterval(boot); }, 45000);
  var observer = new MutationObserver(function (changes) {
    if (changes.some(function (change) {
      var target = change.target;
      if (target.matches?.('[data-myx-summary]') && !target.querySelector('[data-myx-upgrade-summary]')) return true;
      return Array.from(change.addedNodes).some(function (node) { return node.nodeType === 1 && (node.id === 'myx-design-review' || node.querySelector?.('#myx-design-review')); });
    })) render();
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
  var builderWatch = setInterval(function () { var root = document.getElementById('product-builder'); if (!root) return; clearInterval(builderWatch); new MutationObserver(function (changes) { if (changes.some(function (change) { return change.oldValue !== change.target.getAttribute(change.attributeName) && (change.attributeName !== 'class' || change.target.hasAttribute('data-option-id')); })) schedule(); }).observe(root, {subtree:true, attributes:true, attributeOldValue:true, attributeFilter:['aria-pressed','aria-checked','class']}); }, 500);
  setTimeout(function(){clearInterval(builderWatch)},45000);
})();
